<template>
  <v-container id="product-page">
    <v-row>
      <v-col cols="12" sm="6" v-if="items.length > 0">
        <v-carousel hide-delimiters height="400" cycle>
          <span class="discount-label" v-if="product_info.discount_percentage"
            >{{ parseInt(product_info.discount_percentage) }}%</span
          >
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item"
          ></v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="desc">
          <h2 class="main-color">{{ product_info.name }}</h2>

          <div
            class="editIcon"
            :class="locale == 'en' ? 'editIconLtr' : 'editIconRtl'"
          >
            <!--  -->
            <v-btn icon @click="openEditDialog()" v-if="product_info.can_edit">
              <v-icon>edit</v-icon>
            </v-btn>
          </div>

          <p
            class="sub-title grey--text"
            v-if="product_info.grade || product_info.curriculum"
          >
            {{ product_info.grade }} - {{ product_info.curriculum }}
          </p>

          <p class="main-color seller">
            <strong>{{ $t("Seller") }}:</strong> {{ product_info.seller }}
          </p>

          <!-- =========================  tabs ============================ -->
          <div class="tabs-div">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="#13a8b1"
            >
              <v-tabs-slider color="#13a8b1"></v-tabs-slider>
              <v-tab class="">{{ $t("Product description") }}</v-tab>
              <v-tab>{{ $t("Rating") }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="product-desc">
                    {{ product_info.description }}
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    second
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>

          <p class="main-color seller">
            <strong>{{ $t("Available Quantity") }}:</strong>
            {{ product_info.quantity }}
          </p>
          <div class="sizes" v-if="product_info.sizes.length > 0">
            <label for="sizes" class="main-color">{{
              $t("Available Size(s)")
            }}</label>
            <v-chip-group
              active-class="primary--text"
              column
              multiple
              class="text-center"
            >
              <v-chip v-for="(size, index) in product_info.sizes" :key="index">
                {{ size.size }}
                <span class=" quantity-chip">{{ size.quantity }}</span>
              </v-chip>
            </v-chip-group>
          </div>

          <div class="tags">
            <div class="">
              <v-chip class="ma-2" color="rgb(170 216 219)" text-color="white">
                {{ product_info.category }}
              </v-chip>
              <v-chip
                v-for="(tag, index) in product_info.tags"
                :key="index"
                class="ma-2"
                color="rgb(170 216 219)"
                text-color="white"
              >
                {{ tag.name }}
              </v-chip>
            </div>
          </div>

          <div class="add-to-cart">
            <v-row>
              <v-col cols="12" sm="6">
                <p>
                  <span class="main-color sale"
                    >{{
                      product_info.discount_price != ""
                        ? product_info.discount_price
                        : product_info.price
                    }}
                    {{ $t("currency") }}
                  </span>
                  <span
                    class="second-color discount"
                    v-if="product_info.discount_price"
                  >
                    {{ product_info.price }} {{ $t("currency") }}
                  </span>
                </p>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>

    <addEditProductComponent
      :dialog="addproductDialog"
      :productEditData="productEditData"
      :edit="edit"
      v-on:dialogClosed="closeDialog"
    ></addEditProductComponent>
    <Snack ref="snack"></Snack>
  </v-container>
</template>
<script>
import addEditProductComponent from "../../components/addEditProductComponent";

export default {
  name: "productPage",
  components: { addEditProductComponent },

  data() {
    return {
      model: null,
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,
      tab: null,
      product_id: "",
      product_info: {},
      items: [],
      addproductDialog: false,
      productEditData: {},
      edit: false
    };
  },
  methods: {
    getProductInfo() {
      this.$http
        .get(this.getApiUrl + "/seller/product/show/" + this.product_id, {
          headers: {
            Authorization: "Bearer " + localStorage.seller_token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            if (!response.data.data.canShowAndEdit) {
              this.$router.push({ path: "/seller/shop" });
            }
            this.product_info = response.data.data.product;
            this.items = response.data.data.product.images;
          }
        });
    },
    getEditProductInfo() {
      this.$http
        .get(
          this.getApiUrl +
            "/seller/product/show/" +
            this.product_id +
            "?edit=true",
          {
            headers: {
              Authorization: "Bearer " + localStorage.seller_token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            // console.log(response.data.data);
            this.productEditData = response.data.data.product;
            // this.items = response.data.data.images;
          }
        });
    },
    openEditDialog() {
      this.addproductDialog = true;
      this.edit = true;
    },
    closeDialog(refresh) {
      console.log(refresh);
      this.addproductDialog = false;
      this.edit = false;
      if (refresh) {
        this.getProductInfo();
        this.getEditProductInfo();
      }
    }
  },
  mounted() {
    this.product_id = Number(this.$router.currentRoute.params.product_id);

    this.getProductInfo();
    this.getEditProductInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

#product-page {
  .v-carousel {
    width: 90%;

    .discount-label {
      color: #ffffff;
      background-color: #ff0000;
      display: inline-block;
      padding: 5px 10px;
      font-size: 1.5rem;
      border-radius: 10px;
      position: absolute;
      top: 0;
      z-index: 2;
    }
  }
  margin-top: 2rem;
  margin-bottom: 2rem;
  .product-desc {
    font-size: 1.2rem;
  }
  .desc {
    position: relative;
    .editIcon {
      position: absolute;
    }

    .editIconRtl {
      left: 0;
      top: 0;
    }
    .editIconLtr {
      right: 0;
      top: 0;
    }

    .sub-title {
      font-size: 1rem !important;
    }

    .seller {
      font-size: 1rem !important;
    }

    .add-to-cart {
      .v-btn {
        margin: 0 5px !important;
      }
      .discount {
        font-size: 1rem;
        text-decoration: line-through !important;
        color: $main-color !important;
      }
      .sale {
        font-size: 1.5rem;
      }
    }
  }
}

/* products */
.products {
  margin-top: $margin-top;

  .card-title {
    margin-bottom: 0;
  }
  .product {
    position: relative;
    // max-width: 90% !important;

    img {
      max-width: 100% !important;
      margin: 0 auto;
      width: 100%;
    }
    .product-info {
      background-color: $home-overlay;
      width: 100% !important;
      color: #ffffff;
      // opacity: 0.8;
      text-align: center !important;
      position: absolute;
      bottom: 6px;
      p {
        margin-bottom: 2px;
      }
      .v-icon {
        font-size: larger !important;
      }
    }
  }
}
.quantity-chip {
  color: #ffffff;
  background-color: #13a8b1;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  margin: 0 5px;
}

.v-tab {
  font-weight: bold;
  font-size: 1rem;
  background-color: #f2f3f6;
  margin: 0 5px;
  border-radius: 6px;
}
.v-tab.v-tab--active {
  background-color: #25afb7;
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
  border-radius: 6px;
}
</style>
